import {Component, OnInit, NgModule, ViewChild} from '@angular/core';
import {MamAdminService} from "../../service/mam_service.component";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {ButtonModule} from "primeng/components/button/button";
import {DataTableModule} from "primeng/components/datatable/datatable";
import {SharedModule} from "primeng/components/common/shared";
import {CommonModule} from "@angular/common";
import {PaginatorModule, Paginator} from "primeng/components/paginator/paginator";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from "@angular/http";
import {FormsModule} from "@angular/forms";
import {SearchModule} from "../../component/search.component";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger} from "angular2-logger/core";
import {TranslateServiceForm} from "../../translate/translate.service";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {RouterModule} from "@angular/router";
import {CookieService} from "angular2-cookie/services/cookies.service";

@Component({
    selector: 'inOutShow',
    templateUrl: 'inOutShow.html'
})
export class InOutShowComponent implements OnInit {

    selectedCompany : any;
    table_apply_list : any = [];
    table_notApply_list : any = [];
    policyPageMax : number = 10;
    notPolicyPageMax : number = 10;
    totalRecord_apply : any;
    totalRecord_notApply :any;
    POLICY_IN : boolean = true;
    POLICY_OUT : boolean = false;
    searchIsTrue : boolean = false;

    @ViewChild('pagin1') pagin1 : Paginator;
    @ViewChild('pagin2') pagin2 : Paginator;
    searchApplyIsTrue : boolean;
    searchApplyText : any = "";
    selectedApplySearchID : any = "";

    searchNotApplyIsTrue : boolean;
    searchNotApplyText : any = "";
    selectedNotApplySearchID : any = "";
    excelIsTrue : boolean = false;
    companyId : any;
    searchIDs : any;

    pagi1 : any = 0;
    pagi2 : any = 0;

    resetIsTrue : any ='';
    constructor(private service:MamAdminService, private logger : Logger, private _translate: TranslateServiceForm, private cookie : CookieService) {
        //this.getDevicePolicyApplyList(0, 10, "", "", this.POLICY_IN, this.selectedCompany.id); // 출입정책 IN인 단말들
        //this.getDevicePolicyApplyList(0, 10, "", "", this.POLICY_OUT, this.selectedCompany.id); // 출입정책 OUT인 단말들
        this.companyId = cookie.get('companyId');

        this.searchIDs = [];
        this.searchIDs.push({label: '----------------', value: 'all'});
        this.searchIDs.push({label: this._translate.instant('LANG_USR_user'), value: 'name'});
        this.searchIDs.push({label: this._translate.instant('LANG_PhoneNumber'), value: 'mobileNumber'});

    }

    ngOnInit() {

        this.getDevicePolicyApplyList(0, 10, "", "", this.POLICY_IN, this.companyId); // 출입정책 IN인 단말들
        this.getDevicePolicyApplyList(0, 10, "", "", this.POLICY_OUT, this.companyId); // 출입정책 OUT인 단말들
        if(this.pagin1){
            this.pagin1.first=0;
        }
        if(this.pagin2){
            this.pagin2.first=0;
        }
    }

    onSelectedCompany(company) {
        this.selectedCompany = company;
        this.logger.debug("combo - select :" , this.selectedCompany);
        this.resetIsTrue = "true"+this.selectedCompany.id;
    }

    policyApplyPaginate(event) {
        this.policyPageMax = event.rows;
        this.pagi1 = event.page;
        if(this.searchApplyIsTrue){
            this.getDevicePolicyApplyList(this.pagi1, this.policyPageMax, this.searchApplyText, this.selectedApplySearchID, this.POLICY_IN, this.selectedCompany.id );
        }else{
            this.getDevicePolicyApplyList(this.pagi1, this.policyPageMax, '', '', this.POLICY_IN, this.selectedCompany.id );
        }
    }

    notPolicyApplyPaginate(event) {
        this.notPolicyPageMax = event.rows;
        this.pagi2 = event.page;
        if(this.searchNotApplyIsTrue){
            this.getDevicePolicyApplyList(this.pagi2, this.notPolicyPageMax, this.searchNotApplyText, this.selectedNotApplySearchID, this.POLICY_OUT, this.selectedCompany.id );
        }else{
            this.getDevicePolicyApplyList(this.pagi2, this.notPolicyPageMax, '', '', this.POLICY_OUT, this.selectedCompany.id );
        }
    }

    getDevicePolicyApplyList(page: number, max: number, search: string, field: string, applyIsTrue: boolean, companyId : number) {
        this.service.getDevicePolicyApplyList(page, max, search, field, applyIsTrue, companyId).subscribe(
            value => {
                if(applyIsTrue){
                    this.table_apply_list = value.content;
                    this.totalRecord_apply = value.totalElements;
                }else{
                    this.table_notApply_list = value.content;
                    this.totalRecord_notApply = value.totalElements;
                }
            },
            error => { this.logger.error("-- error : " + error);},
            () => { }
        )
    }

    refreshApplyList(event){
        if(this.pagin1){
            this.pagin1.first=0;
        }
        this.getDevicePolicyApplyList(0, 10, "", "", this.POLICY_IN, 1); // 출입정책 IN인 단말들
    }

    refreshNotApplyList(event){
        if(this.pagin2){
            this.pagin2.first=0;
        }
        this.getDevicePolicyApplyList(0, 10, "", "", this.POLICY_OUT, 1); // 출입정책 IN인 단말들
    }

    getApplySearchModel(event){
        this.logger.debug("event : ",event);
        this.searchApplyIsTrue = event.searchIsTrue;
        this.searchApplyText = event.searchText;
        this.selectedApplySearchID = event.searchId;
        this.pagi1 = 0;
        this.getDevicePolicyApplyList(this.pagi1, this.policyPageMax, this.searchApplyText, this.selectedApplySearchID, this.POLICY_IN, this.selectedCompany.id );
        if(this.pagin1){
            this.pagin1.first=0;
            this.pagin1.rows=this.policyPageMax;
        }
    }

    getNotApplySearchModel(event){
        this.logger.debug("event : ",event);
        this.searchNotApplyIsTrue = event.searchIsTrue;
        this.searchNotApplyText = event.searchText;
        this.selectedNotApplySearchID = event.searchId;
        this.pagi2 = 0;
        this.getDevicePolicyApplyList(this.pagi2, this.notPolicyPageMax, this.searchNotApplyText, this.selectedNotApplySearchID, this.POLICY_OUT, this.selectedCompany.id );
        if(this.pagin2){
            this.pagin2.first=0;
            this.pagin2.rows=this.notPolicyPageMax;
        }
    }

    test(){
        console.log("대박");
    }
}

@NgModule({
    imports: [ButtonModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,BrowserModule,HttpModule,FormsModule,SearchModule, SearchDropBoxModule, MainPipeMoudle,  TranslatePipeMoudle, CompanyDropDownListModule, RouterModule],
    exports: [InOutShowComponent],
    declarations: [InOutShowComponent],
    providers: [MamAdminService],
})
export class InOutShowModule {
}


// WEBPACK FOOTER //
// ./src/app/page/log/inOutShow.ts